export const LEAD_GENERATION_FORM_VIEWED = 'Lead Generation Form - Viewed';
export const LEAD_GENERATION_FORM_CONTINUE = 'Lead Generation Form - Continue';
export const LEAD_GENERATION_FORM_SUBMIT = 'Lead Generation Form - Submit';

export const dateContent = [
  {
    month: 'AUG',
    date: 'Aug 1',
    text: 'Registration starts'
  },
  {
    month: 'OCT',
    date: 'Oct 8 and 15',
    text: 'Exam dates'
  },
  {
    month: 'OCT',
    date: 'Oct 21',
    text: 'Result announcement'
  }
];

export const examAndClasses = [
  {
    id: '1',
    label: 'Foundation Class 9',
    value: 'Foundation Class 9'
  },
  {
    id: '2',
    label: 'Foundation Class 10',
    value: 'Foundation Class 10'
  },
  {
    id: '3',
    label: 'IIT JEE Class 11',
    value: 'IIT JEE Class 11'
  },
  {
    id: '4',
    label: 'IIT JEE Class 12',
    value: 'IIT JEE Class 12'
  },
  {
    id: '5',
    label: 'IIT JEE Dropper',
    value: 'IIT JEE Dropper'
  },
  {
    id: '6',
    label: 'NEET UG Class 11',
    value: 'NEET UG Class 11'
  },
  {
    id: '7',
    label: 'NEET UG Class 12',
    value: 'NEET UG Class 12'
  },
  {
    id: '8',
    label: 'NEET UG Dropper',
    value: 'NEET UG Dropper'
  },
  {
    id: '9',
    label: 'Others Class 11',
    value: 'Others Class 11'
  },
  {
    id: '10',
    label: 'Others Class 12',
    value: 'Others Class 12'
  }
];

export const radioOptions = [
  {
    id: 1,
    label: 'At an offline centre',
    value: 'offline'
  },
  {
    id: 2,
    label: 'Online test',
    value: 'online'
  }
];

export const getCities = (cityCenterMapping) => {
  const distinctCities = [];
  cityCenterMapping.forEach((cityObj) => {
    const { city } = cityObj;
    if (distinctCities.indexOf(city) === -1) {
      distinctCities.push(city);
    }
  });
  const citiesOptions = distinctCities.map((disCity, index) => {
    return {
      id: index,
      label: disCity,
      value: disCity
    };
  });
  return citiesOptions;
};

export const getCentres = (cityCenterMapping, selectedCity) => {
  const centres = [];
  cityCenterMapping.forEach((cityObj) => {
    if (cityObj.city === selectedCity?.value) {
      centres.push(cityObj.center);
    }
  });
  const centreOptions = centres.map((disCen, index) => {
    return {
      id: index,
      label: disCen,
      value: disCen
    };
  });
  return centreOptions;
};

const getCityOption = (city, cityCenterMapping) => {
  const cities = getCities(cityCenterMapping);
  return cities.find((cityObj) => cityObj.value === city);
};

const getCenterOption = (center, cityCenterMapping, city) => {
  const centres = getCentres(cityCenterMapping, city);
  return centres.find((cityObj) => cityObj.value === center);
};

export const modifiedFormData = (formData, dateSlots, cityCenterMapping) => {
  const dateAndTimeOption = dateSlots.find(
    (dateObj) => dateObj.value === formData.dateAndTime
  );
  const examAndClassesOption = examAndClasses.find(
    (exam) => exam.value === formData.examAndClass
  );
  const testTypeOption = radioOptions.find(
    (radio) => radio.value === formData.testType
  );

  const city = getCityOption(formData.city, cityCenterMapping);
  const centreOption = getCenterOption(
    formData.centerName,
    cityCenterMapping,
    city
  );
  const updatedData = {
    ...formData,
    dateAndTime: dateAndTimeOption,
    examAndClass: examAndClassesOption,
    testType: testTypeOption,
    centerName: centreOption,
    city
  };
  return updatedData;
};
